export const API_BASE_URL = process.env.REACT_APP_API_URL as string;
export const ADMIN_API_BASE_URL = `${API_BASE_URL}/api/admin`;
// export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL as string;
export const WEBSOCKET_URL = process.env.REACT_APP_API_URL as string;
// Get app mode from localStorage, fallback to environment variable
const getAppMode = (): string => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("appMode") || "crypto";
  }
  return "crypto";
};

export const isStockTradingMode = getAppMode() === "stock";
export const currentAppMode = getAppMode();
